'use strict';
angular.module('authDirectives', []).directive('authDirective', function ($modal) {
    return {
        restrict: 'C',
        link: function (scope, elem, attrs) {
            scope.$on('event:auth-loginRequired', function () {
                console.log('auth-loginRequired');



            });
        }
    };
});